import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from "./shared/shared.module";
import { AppRoutingModule } from './app-routing.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrModule } from 'ngx-toastr';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { NgxPaginationModule } from 'ngx-pagination';
// // for HttpClient import:
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
// // for Router import:
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
// // for Core import:
import { LoadingBarModule } from '@ngx-loading-bar/core';

import { AdminGuard } from './shared/guard/admin.guard';
import { CookieService } from 'ngx-cookie-service';

import { AppComponent } from './app.component';
import { LoginComponent } from './auth/login/login.component';

import { OverlayModule } from '@angular/cdk/overlay';
import { PersonasComponent } from './components/personas/personas/personas.component';
import { ListadosComponent } from './components/personas/listados/listados/listados.component';
import { InactivosComponent } from './components/personas/inactivos/inactivos/inactivos.component';
import { LicenciaComponent } from './components/personas/licencia/licencia/licencia.component';
import { MultasComponent } from './components/personas/multas/multas/multas.component';
import { DataTableComponent } from './components/data-table/data-table.component';
import { MedicosComponent } from './components/personas/medicos/medicos/medicos.component';
import { NuevoComponent } from './components/vehiculos/nuevo/nuevo/nuevo.component';
import { AfiliadosActivosComponent } from './components/vehiculos/afiliados-activos/afiliados-activos/afiliados-activos.component';
import { TercerosActivosComponent } from './components/vehiculos/terceros-activos/terceros-activos/terceros-activos.component';
import { InactivoComponent } from './components/vehiculos/inactivos/inactivo/inactivo.component';
import { ParticularComponent } from './components/vehiculos/particular/particular/particular.component';
import { GeneralComponent } from './components/vehiculos/general/general/general.component';
import { DocumentosComponent } from './components/vehiculos/documentos/documentos/documentos.component';
import { ListadoComponent } from './components/vehiculos/marcas/listado/listado/listado.component';
import { ListadoModeloComponent } from './components/vehiculos/modelo/listado/listado-modelo/listado-modelo.component';
import { AlistamientosDiariosComponent } from './components/vehiculos/alistamientos-diarios/alistamientos-diarios/alistamientos-diarios.component';
import { ConductoresComponent } from './components/vehiculos/conductores/conductores/conductores.component';
import { PolizasComponent } from './components/vehiculos/polizas/polizas/polizas.component';
import { PlanosComponent } from './components/vehiculos/planos/planos/planos.component';
import { ElaborarComponent } from './components/extractos/elaborar/elaborar/elaborar.component';
import { ListadoExtractosComponent } from './components/extractos/listado-extractos/listado-extractos/listado-extractos.component';
import { ConsultarComponent } from './components/extractos/consultar/consultar/consultar.component';
import { ContratosComponent } from './components/extractos/contratos/contratos/contratos.component';
import { CrearComponent } from './components/extractos/rutas/crear/crear/crear.component';
import { ListadoRutasComponent } from './components/extractos/rutas/listado-rutas/listado-rutas/listado-rutas.component';
import { CrearDepartamentoComponent } from './components/extractos/departamentos/crear-departamento/crear-departamento.component';
import { ListadoDepartamentoComponent } from './components/extractos/departamentos/listado-departamento/listado-departamento/listado-departamento.component';
import { NuevaEmpresaComponent } from './components/comercial/empresas/nueva-empresa/nueva-empresa/nueva-empresa.component';
import { EmpresasActivasComponent } from './components/comercial/empresas/empresas-activas/empresas-activas/empresas-activas.component';
import { EmpresasInactivasComponent } from './components/comercial/empresas/empresas-inactivas/empresas-inactivas/empresas-inactivas.component';
import { NuevoCotizacionesComponent } from './components/comercial/cotizaciones/nuevo-cotizaciones/nuevo-cotizaciones/nuevo-cotizaciones.component';
import { ActivosCotizacionesComponent } from './components/comercial/cotizaciones/activos-cotizaciones/activos-cotizaciones/activos-cotizaciones.component';
import { CerradasCotizacionesComponent } from './components/comercial/cotizaciones/cerradas-cotizaciones/cerradas-cotizaciones/cerradas-cotizaciones.component';
import { GeneralCotizacionesComponent } from './components/comercial/cotizaciones/general-cotizaciones/general-cotizaciones/general-cotizaciones.component';
import { RegistrarComponent } from './components/mantenimientos/registrar/registrar/registrar.component';
import { OrdenesComponent } from './components/mantenimientos/ordenes/ordenes/ordenes.component';
import { ListadoMantenimientosComponent } from './components/mantenimientos/listado-mantenimientos/listado-mantenimientos/listado-mantenimientos.component';
import { EnviarComponent } from './components/notificaciones/enviar/enviar/enviar.component';
import { UsuariosAppComponent } from './components/usuarios/usuarios-app/usuarios-app/usuarios-app.component';
import { WebComponent } from './components/usuarios/web/web/web.component';
import { EjecutadasComponent } from './components/usuarios/ejecutadas/ejecutadas/ejecutadas.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { GraficosComponent } from './components/personas/listados/components/graficos/graficos.component';
import { GraficosMultasComponent } from './components/personas/multas/components/graficos/graficos.component';
import { GraficosCupleanosComponent } from './components/personas/cumpleanos/components/graficos/graficos.component';
import { CumpleanosComponent } from './components/personas/cumpleanos/cumpleanos/cumpleanos.component';
import { AgGridModule } from 'ag-grid-angular';
import { MarcasInactivasComponent } from './components/vehiculos/marcas/marcas-inactivas/marcas-inactivas/marcas-inactivas.component';
import { ModeloInactivoComponent} from './components/vehiculos/modelo/modelo-inactivo/modelo-inactivo/modelo-inactivo.component';
import { EditarVehiculoComponent} from './components/vehiculos/afiliados-activos/afiliados-activos/editar-vehiculo/editar-vehiculo/editar-vehiculo.component';
import { DigitalesComponent } from './components/vehiculos/digitales/vehicular/digitales.component';
import { CrearExtractoComponent} from './components/extractos/elaborar/elaborar/crear-extracto/crear-extracto/crear-extracto.component';
import { RutasInactivasComponent} from './components/extractos/rutas/rutas-inactivas/rutas-inactivas/rutas-inactivas.component';
import { DepartamentosInactivosComponent} from './components/extractos/departamentos/departamentos-inactivos/departamentos-inactivos/departamentos-inactivos.component';
import { CombustibleComponent } from './components/mantenimientos/combustible/combustible/combustible.component';
import { ConsultarCombustibleComponent } from './components/mantenimientos/consultar-combustible/consultar-combustible/consultar-combustible.component';
import { DigitalesEmpresasComponent } from './components/comercial/empresas/digitales/digitales-empresas/digitales-empresas.component';
import { SiniestrosVialesComponent } from './components/vehiculos/siniestros-Viales/listado/siniestros-viales/siniestros-viales.component';
import { SiniestrosVialesCrearComponent } from './components/vehiculos/siniestros-Viales/siniestros-viales-crear/siniestros-viales-crear/siniestros-viales-crear.component';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { RegistrarPesvComponent } from './components/pesv/registrar/registrar/registrar.component';
import { ListadoPesvComponent } from './components/pesv/listado-pesv/comite/listado-pesv.component';
import { EditarSiniestroComponent } from './components/vehiculos/siniestros-Viales/editar-siniestro/editar-siniestro/editar-siniestro.component';
import { CartasComponent } from './components/vehiculos/cartas/cartas/cartas.component';
import { PoliticaSeguridadVialComponent } from './components/pesv/politica-seguridad-vial/politica-seguridad-vial/politica-seguridad-vial.component';
import { LiderazgoCompromisoComponent } from './components/pesv/liderazgo-compromiso/liderazgo-compromiso/liderazgo-compromiso.component';
import { DigitalesPesvComponent } from './components/digitales-pesv/digitales-pesv/digitales-pesv.component';
import { DiagnosticoPesvComponent } from './components/pesv/diagnostico/diagnostico/diagnostico.component';
import { ColaboradoresPesvComponent } from './components/pesv/diagnostico/colaboradores/colaboradores.component';
import { ContratistaPesvComponent } from './components/pesv/diagnostico/contratista/contratista.component';
import { VehiculosPesvComponent } from './components/pesv/diagnostico/vehiculos/vehiculos.component';
import { IdentificarRutasPesvComponent } from './components/pesv/diagnostico/identificar_rutas/identificar_rutas.component';
import { EmergenciaComponent } from './components/pesv/diagnostico/emergencia/emergencia.component';
import { RiesgosVialesComponent } from './components/pesv/riesgos_viales/riesgos_viales/riesgos-viales.component';
import { PlanAnualComponent } from './components/pesv/plan-anual/plan-anual/plan-anual.component';
import { ResponderEncuestaComponent } from './components/comercial/encuestas/responder-encuesta/responder-encuesta.component';
import { CapacitacionCatalogoComponent } from './components/personas/capacitaciones/capacitacion-catalogo/capacitacion_catalogo/capacitacion-catalogo.component';
import { RodamientosComponent } from './components/vehiculos/rodamientos/rodamientos.component';
import { InspeccionVehiculosComponent } from './components/pesv/implementacion/inspeccion-vehiculos/inspeccion-vehiculos/inspeccion-vehiculos.component';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { CrearPlanMantenimientosComponent } from './components/mantenimientos/plan-mantenimientos/crear-plan-mantenimientos/crear-plan-mantenimientos.component';
import { ListarPlanMantenimientosComponent } from './components/mantenimientos/plan-mantenimientos/listar-plan-mantenimientos/listar-plan-mantenimientos/listar-plan-mantenimientos.component';

import { TipoProgramaComponent } from './components/pesv/programas-gestion/tipo-programa/tipo-programa/tipo-programa.component';
import { GestionGeneralComponent } from './components/pesv/plan-anual/gestion-general/gestion-general/gestion-general.component';
import { PasosPlanComponent } from './components/pesv/plan-anual/pasos-plan/pasos-plan/pasos-plan.component';
import { GestionPlanComponent } from './components/pesv/plan-anual/gestion-plan/gestion-plan/gestion-plan.component';
import { ProgramaComponent } from './components/pesv/programas-gestion/programas-gestion/programa/programa.component';
import { SeguimientosComponent } from './components/pesv/programas-gestion/seguimientos/seguimientos/seguimientos.component';
import { GestionCompetenciasComponent } from './components/pesv/competencia-plan-anual/gestion-competencias/gestion-competencias/gestion-competencias.component';
import { CompetenciaComponent } from './components/pesv/competencia-plan-anual/competencia/competencia/competencia.component';
import { PlanCompetenciaComponent } from './components/pesv/competencia-plan-anual/plan-competencia/plan-competencia/plan-competencia.component';
import { DocumentosCompetenciaComponent } from './components/pesv/competencia-plan-anual/documentos-competencia/documentos-competencia/documentos-competencia.component';
import { ActividadesComponent } from './components/personas/capacitaciones/capacitaciones-programacion/capacitaciones-programacion/actividades/actividades/actividades.component';
import { CapacitacionesProgramacionComponent } from './components/personas/capacitaciones/capacitaciones-programacion/capacitaciones-programacion/capacitaciones-programacion.component';
import { InvitacionComponent } from './components/personas/capacitaciones/capacitaciones-programacion/capacitaciones-programacion/invitacion/invitacion.component';
import { FirmasModule } from './components/firmas/firmas.module';
import { AsistentesComponent } from './components/personas/capacitaciones/capacitaciones-programacion/capacitaciones-programacion/asistentes/asistentes/asistentes.component';
import { ProgramacionMantenimientosComponent } from './components/mantenimientos/programacion-mantenimientos/programacion-mantenimientos/programacion-mantenimientos.component';
import { GestionarActividadComponent } from './components/mantenimientos/ordenes/gestionar-actividad/gestionar-actividad.component';
import { ListadoPasajerosComponent } from './components/extractos/listado-pasajeros/listado-pasajeros.component';
import { QuejasComponent } from './components/pesv/responsabilidad-comportamiento/quejas/quejas/quejas.component';
import { ResponsabilidadesComponent } from './components/pesv/responsabilidad-comportamiento/responsabilidades/responsabilidades/responsabilidades.component';
import { CriteriosComportamientoComponent } from './components/pesv/responsabilidad-comportamiento/criterios-comportamiento/criterios-comportamiento/criterios-comportamiento.component';
import { EvaluacionComportamientoComponent } from './components/pesv/responsabilidad-comportamiento/evaluacion-comportamiento/evaluacion-comportamiento/evaluacion-comportamiento.component';
import { PlanRefuerzoSeguimientoComponent } from './components/pesv/responsabilidad-comportamiento/plan-refuerzo-seguimiento/plan-refuerzo-seguimiento/plan-refuerzo-seguimiento.component';
import { SeguimientoFormModalComponent } from './components/pesv/responsabilidad-comportamiento/plan-refuerzo-seguimiento/seguimiento-form-modal/seguimiento-form-modal.component';
import { AccionRefuerzoFormModalComponent } from './components/pesv/responsabilidad-comportamiento/plan-refuerzo-seguimiento/accion-refuerzo-form-modal/accion-refuerzo-form-modal.component';
import { TipoComportamientoModule } from './components/pesv/responsabilidad-comportamiento/tipo-comportamiento/tipo-comportamiento.module';
import { AspectosComportamientoModule } from './components/pesv/responsabilidad-comportamiento/aspectos-comportamiento/aspectos-comportamiento.module';
import { SeguimientosQuejasComponent } from './components/pesv/responsabilidad-comportamiento/quejas/quejas/seguimientos-quejas//seguimientos-quejas/seguimientos-quejas.component';
import { DocumentosPlanComponent } from './components/pesv/plan-preparacion-respuesta/documentos/documentos/documentos.component';
import { DocumentosInvestigacionComponent } from './components/pesv/investigacion-interna/documentos-investigacion/documentos-investigacion/documentos-investigacion.component';
import { InvestigacionComponent } from './components/pesv/investigacion-interna/investigacion/investigacion/investigacion.component';
import { ViasInternasComponent } from './components/pesv/vias-seguras-administradas/vias-internas/vias-internas/vias-internas.component';
import { ViasZonasComponent } from './components/pesv/vias-seguras-administradas/vias-zonas/vias-zonas/vias-zonas.component';
import { ViasRiesgosComponent } from './components/pesv/vias-seguras-administradas/vias-zonas/vias-riesgos/vias-riesgos/vias-riesgos.component';
import { ViasInspeccionesComponent } from './components/pesv/vias-seguras-administradas/vias-zonas/vias-inspecciones/vias-inspecciones/vias-inspecciones.component';
import { ViasHallazgosComponent } from './components/pesv/vias-seguras-administradas/vias-hallazgos/vias-hallazgos/vias-hallazgos.component';
import { DocumentosViasComponent } from './components/pesv/vias-seguras-administradas/documentos-vias/documentos-vias/documentos-vias.component';
import { CierreDesplazamientosComponent } from './components/pesv/planificacion-desplazamientos/cierre-desplazamientos/cierre-desplazamientos/cierre-desplazamientos.component';
import { NovedadesDesplazamientosComponent } from './components/pesv/planificacion-desplazamientos/novedades-desplazamientos/novedades-desplazamientos/novedades-desplazamientos.component';
import { SeguimientosDesplazamientosComponent } from './components/pesv/planificacion-desplazamientos/seguimientos-desplazamientos/seguimientos-desplazamientos/seguimientos-desplazamientos.component';
import { RequisitosDesplazamientosComponent } from './components/pesv/planificacion-desplazamientos/requisitos-desplazamientos/requisitos-desplazamientos/requisitos-desplazamientos.component';
import { PuntosCriticosComponent } from './components/pesv/planificacion-desplazamientos/puntos-criticos/puntos-criticos/puntos-criticos.component';
import { RiesgosDesplazamientosComponent } from './components/pesv/planificacion-desplazamientos/riesgos-desplazamientos/riesgos-desplazamientos/riesgos-desplazamientos.component';
import { DesplazamientosComponent } from './components/pesv/planificacion-desplazamientos/desplazamientos/desplazamientos/desplazamientos.component';
import { DocumentosDesplazamientosComponent } from './components/pesv/planificacion-desplazamientos/documentos-desplazamientos/documentos-desplazamientos/documentos-desplazamientos.component';
import { DocumentosGestionCambioComponent } from './components/pesv/cambio-gestion/documentos-gestion-cambio/documentos-gestion-cambio/documentos-gestion-cambio.component';
import { RegistrarRetencionComponent } from './components/pesv/archivo-retencion/registrar-retencion/registrar-retencion/registrar-retencion.component';
import { ListadoRetencionComponent } from './components/pesv/archivo-retencion/listado-retencion/listado-retencion/listado-retencion.component';
import { EditarComponent } from './components/pesv/archivo-retencion/editar-retencion/editar-retencion/editar.component';
import { CertificadosGpsComponent } from './components/gps/certificados-gps/certificados-gps/certificados-gps.component';
import { MantenimientosVehiculosComponent } from './components/pesv/mantenimientos-vehiculos/mantenimientos-vehiculos/mantenimientos-vehiculos.component';
import { ConfiguracionNotificacionesComponent } from './components/notificaciones/configuracion-notificaciones/configuracion-notificaciones/configuracion-notificaciones.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    PersonasComponent,
    ListadosComponent,
    InactivosComponent,
    LicenciaComponent,
    MultasComponent,
    MedicosComponent,
    DataTableComponent,
    NuevoComponent,
    AfiliadosActivosComponent,
    TercerosActivosComponent,
    InactivoComponent,
    ParticularComponent,
    GeneralComponent,
    DocumentosComponent,    
    ListadoComponent,    
    ListadoModeloComponent,
    AlistamientosDiariosComponent,
    ConductoresComponent,
    PolizasComponent,
    PlanosComponent,
    ElaborarComponent,
    ListadoExtractosComponent,
    ConsultarComponent,
    ContratosComponent,
    CrearComponent,
    ListadoRutasComponent,
    CrearDepartamentoComponent,
    ListadoDepartamentoComponent,
    NuevaEmpresaComponent,
    EmpresasActivasComponent,
    EmpresasInactivasComponent,
    NuevoCotizacionesComponent,
    ActivosCotizacionesComponent,
    CerradasCotizacionesComponent,
    GeneralCotizacionesComponent,
    RegistrarComponent,
    OrdenesComponent,
    ListadoMantenimientosComponent,
    EnviarComponent,
    UsuariosAppComponent,
    WebComponent,
    EjecutadasComponent,
    GraficosComponent,
    GraficosMultasComponent,
    CumpleanosComponent,
    GraficosCupleanosComponent,
    MarcasInactivasComponent,
    ModeloInactivoComponent,
    EditarVehiculoComponent,
    DigitalesComponent,
    CrearExtractoComponent,
    RutasInactivasComponent,
    CapacitacionCatalogoComponent,
    DepartamentosInactivosComponent,
    CombustibleComponent,
    ConsultarCombustibleComponent,
    DigitalesEmpresasComponent,
    CapacitacionesProgramacionComponent,
    RegistrarPesvComponent,
    ListadoPesvComponent,
    CartasComponent,
    PoliticaSeguridadVialComponent,
    LiderazgoCompromisoComponent,
    DigitalesPesvComponent,
    DiagnosticoPesvComponent,
    ColaboradoresPesvComponent,
    ContratistaPesvComponent,
    VehiculosPesvComponent,
    IdentificarRutasPesvComponent,
    EmergenciaComponent,
    RiesgosVialesComponent,
    PlanAnualComponent,
    InvitacionComponent,
    ResponderEncuestaComponent,  
    InspeccionVehiculosComponent,
    SiniestrosVialesCrearComponent,
    SiniestrosVialesComponent,
    EditarSiniestroComponent,
    ResponderEncuestaComponent,
    SafeUrlPipe,
    CrearPlanMantenimientosComponent,
    ListarPlanMantenimientosComponent,       
    TipoProgramaComponent, 
    SeguimientosComponent,     
    ProgramaComponent,
    GestionGeneralComponent, 
    PasosPlanComponent,
    GestionPlanComponent,
    GestionCompetenciasComponent,
    CompetenciaComponent,
    PlanCompetenciaComponent,
    DocumentosCompetenciaComponent,
    ActividadesComponent,
    AsistentesComponent,
    ProgramacionMantenimientosComponent,
    GestionarActividadComponent,
    ListadoPasajerosComponent,
    DocumentosPlanComponent,

    // quejas
    QuejasComponent, 
    // responsabilidades
    ResponsabilidadesComponent, 
    // criterios de comportamiento
    CriteriosComportamientoComponent, 
    // fin criterios de comportamiento
    EvaluacionComportamientoComponent, 
    // fin evaluacion de comportamiento
    PlanRefuerzoSeguimientoComponent, 
    // plan de refuerzo y seguimiento
    SeguimientoFormModalComponent, 
    // fin plan de refuerzo y seguimiento
    AccionRefuerzoFormModalComponent, 
    // fin accion de refuerzo
    SeguimientosQuejasComponent,
    // investigacion interna de siniestros
    InvestigacionComponent,
    // fin investigacion interna de siniestros
    DocumentosInvestigacionComponent,
    // documentos vias
    DocumentosViasComponent,
    // vias internas
    ViasInternasComponent,
    // vias zonas
    ViasZonasComponent,
    // vias riesgos
    ViasRiesgosComponent,
    // vias inspecciones
    ViasInspeccionesComponent,
    // vias hallazgos
    ViasHallazgosComponent,
    // documentos de desplazamientos
    DocumentosDesplazamientosComponent,
    // desplazamientos
    DesplazamientosComponent,
    // riesgos de desplazamientos
    RiesgosDesplazamientosComponent,
    // puntos críticos
    PuntosCriticosComponent,
    // requisitos de desplazamientos
    RequisitosDesplazamientosComponent,
    // seguimientos de desplazamientos
    SeguimientosDesplazamientosComponent,
    // novedades de desplazamientos
    NovedadesDesplazamientosComponent,
    // cierre de desplazamientos
    CierreDesplazamientosComponent,
    // documentos de gestión del cambio
    DocumentosGestionCambioComponent,
    // archivo y retención
    ListadoRetencionComponent,
    // registrar retención
    RegistrarRetencionComponent,
    // editar retención
    EditarComponent,


    CertificadosGpsComponent,
    MantenimientosVehiculosComponent,
    ConfiguracionNotificacionesComponent
    
   // ListadosComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    OverlayModule,
    SharedModule,
    AppRoutingModule,
    HttpClientModule,
    NgbModule,
    NgSelectModule,
    NgxDropzoneModule,
    NgxPaginationModule,
    FirmasModule,
    ToastrModule.forRoot(),
    NgApexchartsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      },
    }),
    
  // for HttpClient use:
    LoadingBarHttpClientModule,
  // for Router use:
    LoadingBarRouterModule,
  // for Core use:
    LoadingBarModule,
    NgxPaginationModule,
    AgGridModule, 
  ],
  providers: [ AdminGuard, CookieService ,{
    provide: HTTP_INTERCEPTORS,
    useClass: AuthInterceptor,
    multi: true
  }],
  bootstrap: [AppComponent]
})
export class AppModule { }
